// extracted by mini-css-extract-plugin
module.exports = {"container":"SideNav_container__68xJV","slice":"SideNav_slice__LG2cU","button":"SideNav_button__xTBBK","button_interior":"SideNav_button_interior__aNKjp"};